import { createLogic } from 'redux-logic';

import dotProp from 'dot-prop';

import { bulkUpsert } from 'actions/entities';

import subscribeCalendarSync from 'channels/calendarSync';
import subscribeGenerateConsultationsRuns from 'channels/generateConsultations';
import subscribeTagEventsRuns from 'channels/tagEventsRun';

const subscribeCalendarLogic = createLogic({
  type: bulkUpsert('calendar', {}).type,
  process({ getState, action }, dispatch, done) {
    console.log("subbing")
    if (action.payload) {
      Object.keys(action.payload).forEach( (calendarId) => {
        subscribeCalendarSync(calendarId)
        subscribeGenerateConsultationsRuns(calendarId)
        subscribeTagEventsRuns(calendarId)
      })
    }
    done();
  }
})

// TODO delete calendar unsubscribe

export default [subscribeCalendarLogic];
